// Order Items

export const ADD_ORDER_ITEM = 'ADD_ORDER_ITEM';
export const REMOVE_ORDER_ITEM = 'REMOVE_ORDER_ITEM';
export const REMOVE_ALL_ORDER_ITEMS = 'REMOVE_ALL_ORDER_ITEMS';
export const INC_ORDER_ITEM = 'INC_ORDER_ITEM';
export const DEC_ORDER_ITEM = 'DEC_ORDER_ITEM';